var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z",
  fill: "#FB9C33",
  fillRule: "evenodd"
})));

export default SvgIconStar;